import {TimelineLite} from "gsap";
import {StageLayer} from "@nolimitcity/slot-keypad/bin/core/app/StageLayer";

export class DFBlackBgView extends PIXI.Container implements StageLayer {

    private readonly _blackBg: PIXI.Graphics;

    constructor() {
        super();
        this.name = "DFBlackBgView";
        this._blackBg = new PIXI.Graphics().beginFill(0x000000, 1).drawRect(-480, -480, 1680, 1680).endFill();
        this._blackBg.visible = false;
        this.addChild(this._blackBg);
    }

    public showBlackBg(): void {
        const tl: TimelineLite = new TimelineLite();

        tl.add(() => {
            this._blackBg.alpha = 0;
            this._blackBg.visible = true;
        });
        tl.to(this._blackBg, {
            duration: 0.3,
            alpha: 0.7
        });
    }

    public onComplete(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        tl.to(this._blackBg, {
            duration: 0.1,
            alpha: 0
        }, 0);
        tl.add(() => {
            this._blackBg.visible = false;
            this._blackBg.alpha = 0.7;
        }, 0.1);
        return tl;
    }
}